import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { COLORS } from "./constants"
import type { RaceCount } from "./types"

interface RaceDetailTableProps {
  raceStats: RaceCount[]
}

export const RaceDetailTable = ({ raceStats }: RaceDetailTableProps) => {
  const maxCount = Math.max(...raceStats.map((r) => r.count))

  return (
    <Card className="dark:bg-gray-800">
      <CardHeader>
        <CardTitle className="text-base sm:text-lg">Detalle por Raza</CardTitle>
      </CardHeader>
      <CardContent className="p-2 sm:p-6">
        <div className="overflow-x-auto -mx-2 sm:mx-0">
          <div className="inline-block min-w-full align-middle">
            <table className="min-w-full">
              <thead>
                <tr className="border-b">
                  <th className="text-left py-2 px-1 sm:px-2 text-xs sm:text-sm font-medium">
                    Raza
                  </th>
                  <th className="text-right py-2 px-1 sm:px-2 text-xs sm:text-sm font-medium">
                    Jugadores
                  </th>
                  <th className="text-right py-2 px-1 sm:px-2 text-xs sm:text-sm font-medium">%</th>
                  <th className="text-left py-2 px-1 sm:px-2 text-xs sm:text-sm font-medium hidden sm:table-cell">
                    Representación
                  </th>
                </tr>
              </thead>
              <tbody>
                {raceStats.map((race, index) => (
                  <tr key={race.name} className="border-b">
                    <td className="py-2 px-1 sm:px-2 font-medium text-xs sm:text-sm">
                      <div className="flex items-center gap-1 sm:gap-2">
                        <div
                          className="w-3 h-3 sm:w-4 sm:h-4 rounded flex-shrink-0"
                          style={{
                            backgroundColor: COLORS[index % COLORS.length],
                          }}
                        />
                        <span className="truncate">{race.name}</span>
                      </div>
                    </td>
                    <td className="py-2 px-1 sm:px-2 text-right text-xs sm:text-sm">
                      {race.count}
                    </td>
                    <td className="py-2 px-1 sm:px-2 text-right text-xs sm:text-sm">
                      {race.percentage}%
                    </td>
                    <td className="py-2 px-1 sm:px-2 hidden sm:table-cell">
                      <div className="flex items-center gap-2">
                        <div
                          className="h-2 bg-current rounded min-w-[10px]"
                          style={{
                            width: `${Math.max(10, (race.count / maxCount) * 60)}px`,
                            backgroundColor: COLORS[index % COLORS.length],
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
